import { DataMap } from '@grapecity/wijmo.grid'

import { ListItem } from '../../shared'

export interface PartsFluidsEquipmentContext {
    equipmentOptions: ListItem<string>[]
    equipmentDataMap: DataMap
    canEdit: boolean
    refresh(): void
    equipmentDisplay(code: string | null | undefined): string
}

export interface VpEquipmentRow {
    equipment: string
    description: string
}

export function buildEquipmentLookup(equipment: VpEquipmentRow[]) {
    const sorted = equipment.orderBy((x: VpEquipmentRow) => x.equipment)
    const equipmentOptions = sorted.map(x => new ListItem(x.equipment, x.equipment + ': ' + x.description))
    const equipmentDataMap = new DataMap(
        sorted.map(x => ({ key: x.equipment, display: x.equipment + ': ' + x.description })),
        'key',
        'display',
    )
    const equipmentDisplayByCode = new Map(sorted.map(x => [x.equipment, x.equipment + ': ' + x.description] as const))
    return { equipmentOptions, equipmentDataMap, equipmentDisplayByCode }
}

export function formatEquipmentDisplay(code: string | null | undefined, lookup: Map<string, string>) {
    if (!code) return ''
    return lookup.get(code) ?? code
}
